import { render } from "./GalleryItemsSection.vue?vue&type=template&id=0b2311f4"
import script from "./GalleryItemsSection.vue?vue&type=script&lang=js"
export * from "./GalleryItemsSection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0b2311f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b2311f4', script)) {
    api.reload('0b2311f4', script)
  }
  
  module.hot.accept("./GalleryItemsSection.vue?vue&type=template&id=0b2311f4", () => {
    api.rerender('0b2311f4', render)
  })

}

script.__file = "resources/js/Pages/Station/Gallery/GalleryItemsSection.vue"

export default script